<!-- Modal principal -->
<div
*ngIf="openProducts"
class="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
<div class="relative p-4 w-full max-w-2xl">
  <div class="relative bg-white rounded-lg shadow dark:bg-gray-800">
    <!-- Encabezado del modal -->
    <div class="flex justify-between items-center p-4 border-b dark:border-gray-600">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Agregar Producto
      </h3>
      <button
      (click)="toogleModalProduct()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>

    <form class="p-4" (ngSubmit)="productService()">
      <div class="grid gap-4 sm:grid-cols-2 w-full">
        <div class="sm:col-span-2">
          <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Código<span class="text-red-500">*</span></label>
          <input
          [(ngModel)]="newProduct.type"
          type="text"
          name="product"
          id="product"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          placeholder="Ejem. SEGUROS_CARACAS"
          >
          <span class="text-red-500 text-sm" *ngIf="errorType">Producto requerido</span>
        </div>

      

        <div class="sm:col-span-2">
          <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nombre<span class="text-red-500">*</span></label>
          <input
          [(ngModel)]="newProduct.name"
          type="text"
          name="product"
          id="product"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          placeholder="Ejem. Seguros Caracas"
          >
          <span class="text-red-500 text-sm" *ngIf="errorName">Nombre requerido</span>
        </div>

        <div class="sm:col-span-2">
          <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Descripción</label>
          <textarea
            [(ngModel)]="newProduct.description"
            type="text"
            name="product"
            id="product"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 h-36"
            placeholder="Ejem. Productos de seguros Caracas"></textarea>
        </div>

      </div>
      <div class="flex items-center space-x-4 mt-4">
        <button type="submit" class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 w-[100%]">
          Agregar Producto
        </button>
      </div>
    </form>
  </div>
</div>
</div>

<!-- Modal para asociar etiquetas -->
<div
*ngIf="isModalDynamicCodesOpen"
class="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
<div class="relative p-4 w-full max-w-4xl">
  <div class="relative bg-white rounded-lg shadow dark:bg-gray-800">
    <!-- Encabezado del modal -->
    <div class="flex justify-between items-center p-6 border-b dark:border-gray-600">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        Asociar Etiqueta a Producto
      </h3>
      <button
      (click)="toggleModalDynamicCodes()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>

    <div class="p-6">
      <div class="grid gap-6 lg:grid-cols-2">
        
        <!-- Left Column - Product and Category Selection -->
        <div class="space-y-6">
          <!-- Selector de tipo de producto (solo se muestra en vista principal) -->
          <div *ngIf="currentView === 'main'">
            <label for="productType" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              <i class="fas fa-box mr-2 text-blue-500"></i>
              Producto<span class="text-red-500">*</span>
            </label>
            <select
            [(ngModel)]="selectedProductForDynamic"
            name="productType"
            id="productType"
            (change)="selectProductForDynamicCodes($event)"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option selected value="">Selecciona un producto</option>
              <option *ngFor="let item of productArray" [value]="item?.params?.code">{{item?.params?.code}} - {{item?.params?.name}}</option>
            </select>
            <span class="text-red-500 text-sm" *ngIf="errorProductDynamic">Producto requerido</span>
          </div>

          <!-- Información del producto seleccionado (solo se muestra en vista de detalle) -->
          <div *ngIf="currentView === 'detail' && selectedProductType" class="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div class="flex items-center">
              <i class="fas fa-info-circle text-blue-500 mr-3"></i>
              <div>
                <p class="text-sm font-medium text-blue-800">Asociando etiqueta para:</p>
                <p class="text-sm text-blue-700">
                  <strong>{{selectedProductType?.params?.code}}</strong> - {{selectedProductType?.params?.name}}
                </p>
              </div>
            </div>
          </div>

          <!-- Estadísticas -->
          <div class="bg-gray-50 rounded-lg p-4">
            <h4 class="text-sm font-medium text-gray-800 mb-3">Estadísticas</h4>
            <div class="grid grid-cols-2 gap-4 text-center">
              <div>
                <div class="text-2xl font-bold text-blue-600">{{availableDynamicCodes.length}}</div>
                <div class="text-xs text-gray-600">Disponibles</div>
              </div>
              <div>
                <div class="text-2xl font-bold text-green-600">{{dynamicCodesForProduct.length}}</div>
                <div class="text-xs text-gray-600">Asociadas</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column - Tag Selection with Autocomplete -->
        <div class="space-y-6">
          <!-- Buscador/Autocompletar de etiquetas -->
          <div>
            <label for="dynamicCodeSearch" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              <i class="fas fa-search mr-2 text-purple-500"></i>
              Buscar y Seleccionar Etiqueta<span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <input
                type="text"
                [(ngModel)]="searchDynamicCode"
                (input)="filterAvailableCodes()"
                (focus)="showDropdown = true"
                (blur)="onSearchBlur()"
                placeholder="Escribe para buscar etiquetas..."
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 pr-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <i class="fas fa-search text-gray-400"></i>
              </div>
              
              <!-- Dropdown de resultados -->
              <div *ngIf="showDropdown && filteredAvailableCodes.length > 0" 
                   class="absolute z-10 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto mt-1">
                <div 
                  *ngFor="let code of filteredAvailableCodes" 
                  (click)="selectCodeFromDropdown(code)"
                  class="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0">
                  <div class="flex items-center justify-between">
                    <div>
                      <div class="font-medium text-gray-900">{{code.code}}</div>
                      <div class="text-sm text-gray-600">{{code.name}}</div>
                    </div>
                    <i class="fas fa-plus text-blue-500"></i>
                  </div>
                </div>
              </div>

              <!-- Mensaje cuando no hay resultados -->
              <div *ngIf="showDropdown && searchDynamicCode && filteredAvailableCodes.length === 0" 
                   class="absolute z-10 w-full bg-white border border-gray-300 rounded-lg shadow-lg mt-1 p-4 text-center text-gray-500">
                <i class="fas fa-search text-gray-400 mb-2"></i>
                <p>No se encontraron etiquetas con "{{searchDynamicCode}}"</p>
              </div>
            </div>
            <span class="text-red-500 text-sm" *ngIf="errorDynamicCode">Etiqueta requerida</span>
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Se muestran todas las etiquetas activas excepto las de categoría "persona" que no están asociadas al producto seleccionado
            </p>
          </div>

          <!-- Etiqueta seleccionada -->
          <div *ngIf="selectedDynamicCode" class="bg-green-50 border border-green-200 rounded-lg p-4">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm font-medium text-green-800">Etiqueta seleccionada:</p>
                <p class="text-sm text-green-700">
                  <strong>{{selectedDynamicCode}}</strong>
                </p>
              </div>
              <button (click)="clearSelectedCode()" class="text-green-600 hover:text-green-800">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- Vista rápida de etiquetas ya asociadas -->
          <div *ngIf="dynamicCodesForProduct.length > 0">
            <h4 class="text-sm font-medium text-gray-800 mb-3">
              <i class="fas fa-link mr-2"></i>
              Etiquetas ya asociadas ({{dynamicCodesForProduct.length}})
            </h4>
            <div class="max-h-32 overflow-y-auto space-y-2">
              <div *ngFor="let item of dynamicCodesForProduct" 
                   class="flex items-center justify-between bg-gray-50 rounded-lg p-2">
                <span class="text-sm text-gray-700">{{item.code}}</span>
                <button 
                  (click)="removeDynamicCodeFromProduct(item.code)"
                  class="text-red-500 hover:text-red-700 text-xs">
                  <i class="fas fa-unlink"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="flex items-center justify-end space-x-4 mt-8 pt-6 border-t border-gray-200">
        <button 
          type="button" 
          (click)="toggleModalDynamicCodes()" 
          class="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:ring-4 focus:ring-gray-300 transition-colors">
          Cancelar
        </button>
        <button 
          type="button" 
          (click)="associateDynamicCode()" 
          [disabled]="!selectedDynamicCode"
          class="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          <i class="fas fa-link mr-2"></i>
          Asociar Etiqueta
        </button>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Modal component -->
<div>
  <app-modal-type-product 
    [abrirModal]="isModalOpen" 
    [selectedProductCode]="currentView === 'detail' ? selectedProductType?.params?.code : null"
    (codeAdded)="onCodeAdded()">
  </app-modal-type-product>
</div>

<!-- MAIN VIEW - Product Types List -->
<div *ngIf="currentView === 'main'">
  <!-- Header with breadcrumb -->
  <section class="bg-white border-b">
    <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 py-4">
      <div class="flex items-center space-x-2 text-sm text-gray-500">
        <a href="/console/dashboard" class="hover:text-gray-700 flex items-center">
          <i class="fas fa-arrow-left mr-2"></i>
          Volver al Dashboard
        </a>
        <span class="text-gray-300">|</span>
        <i class="fas fa-tag text-gray-400"></i>
        <span class="font-medium text-gray-700">Sistema de Productos</span>
      </div>
    </div>
  </section>

  <!-- Main content -->
  <section class="min-h-screen">
    <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 py-8">
      
      <!-- Title and description -->
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Sistema de Productos</h1>
        <p class="text-gray-600">Gestión integral de productos para el sistema financiero</p>
      </div>

      <!-- Action buttons -->
      <div class="flex flex-col items-start py-4 space-y-3 md:flex-row md:items-center md:space-y-0 md:justify-between mb-6">
        <div class="flex items-center space-x-4">
          <h2 class="text-xl font-semibold text-gray-800 flex items-center">
            <i class="fas fa-list mr-2 text-gray-600"></i>
            Productos
          </h2>
          <span class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
            {{productArray.length}} productos disponibles
          </span>
        </div>
        
        <div class="flex items-center space-x-4">
          <!-- View Toggle -->
          <div class="flex items-center space-x-2">
            <span class="text-sm text-gray-600">Vista:</span>
            <div class="flex bg-gray-100 rounded-md p-1">
              <button 
                (click)="viewMode = 'list'"
                [class.bg-white]="viewMode === 'list'"
                [class.shadow-sm]="viewMode === 'list'"
                [class.text-blue-600]="viewMode === 'list'"
                class="px-3 py-1 text-sm font-medium rounded transition-colors hover:text-blue-600">
                <i class="fas fa-list mr-1"></i>
                Lista
              </button>
              <button 
                (click)="viewMode = 'cards'"
                [class.bg-white]="viewMode === 'cards'"
                [class.shadow-sm]="viewMode === 'cards'"
                [class.text-blue-600]="viewMode === 'cards'"
                class="px-3 py-1 text-sm font-medium rounded transition-colors hover:text-blue-600">
                <i class="fas fa-th mr-1"></i>
                Tarjetas
              </button>
            </div>
          </div>
          
          <button data-rbac-permiso="config.productos.create" *ngIf="_auth.hasPermission('config.productos.create')" (click)="toogleModalProduct()" type="button" class="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-colors">
            <i class="fas fa-plus mr-2"></i>
            <span class="font-medium">Nuevo Producto</span>
          </button>
        </div>
      </div>

      <!-- Vista Lista (por defecto) -->
      <div *ngIf="viewMode === 'list'" class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-8">
        <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div class="flex justify-between items-center">
            <h3 class="text-lg font-medium text-gray-900">Lista de Productos</h3>
            <span class="text-sm text-gray-600">{{productArray.length}} productos</span>
          </div>
        </div>

        <div *ngIf="productArray.length > 0" class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Producto</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descripción</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acción</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let item of productArray" 
                  class="hover:bg-gray-50 transition-colors cursor-pointer"
                  (click)="selectProductType(item)">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center justify-center">
                    <span class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-800 text-sm font-semibold">
                      {{item?.params?.display_order !== undefined ? item?.params?.display_order : 0}}
                    </span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                      <i class="fas fa-tag text-blue-600"></i>
                    </div>
                    <div>
                      <div class="text-sm font-medium text-gray-900">{{item?.params?.name}}</div>
                      <div class="text-sm text-gray-500">{{item?.params?.code}}</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [class.bg-green-100]="item?.params?.status"
                        [class.text-green-800]="item?.params?.status"
                        [class.bg-red-100]="!item?.params?.status"
                        [class.text-red-800]="!item?.params?.status">
                    {{item?.params?.status ? 'Activo' : 'Inactivo'}}
                  </span>
                </td>
                <td class="px-6 py-4">
                  <div class="text-sm text-gray-900 max-w-xs truncate">
                    {{item?.params?.description || 'Sin descripción disponible'}}
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{item?.params?.date | date: 'dd/MM/yyyy'}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button data-rbac-permiso="config.productos.config" *ngIf="_auth.hasPermission('config.productos.config')" (click)="selectProductType(item); $event.stopPropagation()" 
                          class="text-blue-600 hover:text-blue-900 transition-colors">
                    <i class="fas fa-cog mr-1"></i>
                    Gestionar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty state for list view -->
        <div *ngIf="productArray.length === 0" class="text-center py-12">
          <i class="fas fa-inbox text-gray-400 text-3xl mb-3"></i>
          <p class="text-gray-600">No hay productos disponibles</p>
          <p class="text-sm text-gray-500 mt-1">Crea el primer producto usando el botón "Nuevo Producto"</p>
        </div>
      </div>

      <!-- Vista Tarjetas -->
      <div *ngIf="viewMode === 'cards'">
        <!-- Product Type Cards Grid -->
        <div *ngIf="productArray.length > 0" class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mb-8">
          <div 
            *ngFor="let item of productArray" 
            (click)="_auth.hasPermission('config.productos.config') ? selectProductType(item) : null"
            [class.cursor-pointer]="_auth.hasPermission('config.productos.config')"
            [class.cursor-not-allowed]="!_auth.hasPermission('config.productos.config')"
            [class.opacity-50]="!_auth.hasPermission('config.productos.config')"
            class="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md hover:border-blue-300 transition-all duration-200 group">
            
            <div class="p-6">
              <!-- Header with icon and status -->
              <div class="flex items-start justify-between mb-4">
                <div class="flex items-center">
                  <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                    <i class="fas fa-tag text-blue-600"></i>
                  </div>
                  <div class="flex-1">
                    <span class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                      {{item?.params?.code}}
                    </span>
                  </div>
                </div>
                <div class="flex items-center">
                  <div class="w-2 h-2 mr-2 rounded-full" [ngClass]="item?.params?.status ? 'bg-green-500' : 'bg-red-500'"></div>
                  <span class="text-xs font-medium" [ngClass]="item?.params?.status ? 'text-green-700' : 'text-red-700'">
                    {{item?.params?.status ? 'Activo' : 'Inactivo'}}
                  </span>
                </div>
              </div>

              <!-- Product name -->
              <h3 class="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                {{item?.params?.name}}
              </h3>

              <!-- Description -->
              <p class="text-sm text-gray-600 mb-4 line-clamp-2">
                {{item?.params?.description || 'Sin descripción disponible'}}
              </p>

              <!-- Footer with date and action -->
              <div class="flex items-center justify-between pt-4 border-t border-gray-100">
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-calendar-alt mr-1"></i>
                  <span>{{item?.params?.date | date: 'dd/MM/yyyy'}}</span>
                </div>
                <div class="flex items-center text-blue-600 group-hover:text-blue-700 transition-colors">
                  <span class="text-xs font-medium mr-1">Gestionar</span>
                  <i class="fas fa-arrow-right text-xs"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state for cards view -->
        <div *ngIf="productArray.length === 0" class="text-center py-12">
          <i class="fas fa-inbox text-gray-400 text-3xl mb-3"></i>
          <p class="text-gray-600">No hay productos disponibles</p>
          <p class="text-sm text-gray-500 mt-1">Crea el primer producto usando el botón "Nuevo Producto"</p>
        </div>
      </div>

      <!-- Info message -->
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start">
        <i class="fas fa-info-circle text-blue-500 mr-3 mt-0.5"></i>
        <div>
          <p class="text-sm text-blue-800">
            <strong>Instrucciones:</strong> Haga clic en un producto para gestionar sus categorías, etiquetas y configuración financiera.
          </p>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- DETAIL VIEW - Filtered Sections -->
<div *ngIf="currentView === 'detail' && selectedProductType">
  <!-- Header with navigation -->
  <section class="bg-white border-b">
    <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 py-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <button 
            (click)="goBackToMain()" 
            class="flex items-center text-gray-600 hover:text-gray-800 transition-colors">
            <i class="fas fa-arrow-left mr-2"></i>
            <span class="font-medium">Volver</span>
          </button>
          
          <div class="flex items-center space-x-2">
            <i class="fas fa-tag text-gray-400"></i>
            <span class="text-xl font-semibold text-gray-800">{{selectedProductType?.params?.name}}</span>
            <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{selectedProductType?.params?.code}}
            </span>
          </div>
        </div>
        
        <div class="flex items-center space-x-2">
          <div class="w-2 h-2 mr-2 rounded-full" [ngClass]="selectedProductType?.params?.status ? 'bg-green-500' : 'bg-red-500'"></div>
          <span class="text-sm font-medium" [ngClass]="selectedProductType?.params?.status ? 'text-green-700' : 'text-red-700'">
            {{selectedProductType?.params?.status ? 'Activo' : 'Inactivo'}}
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- Filtered Sections Content -->
  <section class="min-h-screen">
    <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 py-8">
      
      <!-- CONFIGURACIÓN DE SEGUROS Section -->
      <div class="bg-white shadow-md rounded-lg mb-8">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center">
            <i class="fas fa-shield-alt text-gray-600 mr-3"></i>
            <h2 class="text-xl font-bold text-gray-800">Configuración de Seguros</h2>
          </div>
        </div>

        <div class="p-6">
          <!-- INSURANCE Configuration -->
          <div class="bg-gray-50 rounded-lg p-4">
            <div class="flex items-center mb-4">
              <h3 class="font-semibold text-gray-800 mr-3">Producto de Seguros</h3>
              <label class="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  [(ngModel)]="remanenteNeteoForm.insurance.is_insurance_product"
                  (change)="onInsuranceToggle()"
                  class="sr-only peer" />
                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
              </label>
            </div>

            <div *ngIf="remanenteNeteoForm.insurance.is_insurance_product">
              <label class="block text-sm font-medium text-gray-700 mb-2">Aseguradora<span class="text-red-500">*</span></label>
              <select
                [(ngModel)]="remanenteNeteoForm.insurance.insurer_code"
                (change)="validateInsuranceInsurer()"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                [disabled]="insurers.length === 0">
                <option value="">{{insurers.length === 0 ? 'No hay aseguradoras disponibles' : 'Seleccionar aseguradora'}}</option>
                <option *ngFor="let insurer of insurers" [value]="insurer.code">{{insurer.name}}</option>
              </select>
              <span class="text-red-500 text-sm" *ngIf="errorInsuranceInsurer">Aseguradora requerida</span>
              <p class="text-xs text-gray-500 mt-1">Selecciona la aseguradora correspondiente a este producto de seguros</p>
            </div>
          </div>

          <!-- Save button -->
          <div class="mt-6 flex justify-end">
            <button (click)="saveRemanenteNeteoConfig()" type="button" class="flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-colors">
              <i class="fas fa-save mr-2"></i>
              Guardar Configuración
            </button>
          </div>
        </div>
      </div>
      
      <!-- IDENTIFICADORES Section -->
      <div class="bg-white shadow-md rounded-lg mb-8">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <i class="fas fa-list-ul text-gray-600 mr-3"></i>
              <h2 class="text-xl font-bold text-gray-800">IDENTIFICADORES</h2>
              <span class="ml-3 bg-gray-100 text-gray-700 text-sm px-2.5 py-0.5 rounded-full">
                {{itemProduct.length}} productos
              </span>
            </div>
            <button (click)="toggleModal()" type="button" class="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-colors">
              <i class="fas fa-plus mr-2"></i>
              <span class="font-medium">Nuevo identificador</span>
            </button>
          </div>
        </div>

        <div class="p-6">
          <div *ngIf="itemProduct.length > 0; else noCategoryData" class="overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-500">
              <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" class="px-4 py-3">Producto</th>
                  <th scope="col" class="px-4 py-3">Nombre</th>
                  <th scope="col" class="px-4 py-3">Descripción</th>
                  <th scope="col" class="px-4 py-3 text-center">Secuencia</th>
                  <th scope="col" class="px-4 py-3">Creado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of itemProduct" class="border-b hover:bg-gray-50">
                  <td class="px-4 py-3">
                    <span class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">{{item?.code}}</span>
                  </td>
                  <td class="px-4 py-3 font-medium text-gray-900">{{item?.name}}</td>
                  <td class="px-4 py-3 text-gray-700">{{item?.description}}</td>
                  <td class="px-4 py-3 text-center">{{item?.number !== null ? item?.number : '-'}}</td>
                  <td class="px-4 py-3 text-gray-600">{{item?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <ng-template #noCategoryData>
            <div class="text-center py-8">
              <i class="fas fa-inbox text-gray-400 text-3xl mb-3"></i>
              <p class="text-gray-600">No hay productos en esta categoría</p>
              <p class="text-sm text-gray-500 mt-1">Agrega el primer producto usando el botón "Nuevo identificador"</p>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- ETIQUETAS Section -->
      <div class="bg-white shadow-md rounded-lg mb-8">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <i class="fas fa-code text-gray-600 mr-3"></i>
              <h2 class="text-xl font-bold text-gray-800">ETIQUETAS</h2>
              <span class="ml-3 bg-gray-100 text-gray-700 text-sm px-2.5 py-0.5 rounded-full">
                {{dynamicCodesForProduct.length}} etiquetas
              </span>
            </div>
            <button (click)="toggleModalDynamicCodes()" type="button" class="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-colors">
              <i class="fas fa-plus mr-2"></i>
              <span class="font-medium">Nueva etiqueta</span>
            </button>
          </div>
        </div>

        <div class="p-6">
          <div *ngIf="dynamicCodesForProduct.length > 0; else noDynamicCodesData" class="overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-500">
              <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" class="px-4 py-3">Código</th>
                  <th scope="col" class="px-4 py-3">Nombre</th>
                  <th scope="col" class="px-4 py-3 text-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of dynamicCodesForProduct" class="border-b hover:bg-gray-50">
                  <td class="px-4 py-3">
                    <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">{{item?.code}}</span>
                  </td>
                  <td class="px-4 py-3 font-medium text-gray-900">{{item?.name}}</td>
                  <td class="px-4 py-3 text-center">
                    <button class="bg-red-600 w-8 h-8 rounded-md hover:bg-red-700 transition-colors" (click)="removeDynamicCodeFromProduct(item?.code)">
                      <i class="fas fa-trash-alt text-white text-sm"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <ng-template #noDynamicCodesData>
            <div class="text-center py-8">
              <i class="fas fa-code text-gray-400 text-3xl mb-3"></i>
              <p class="text-gray-600">No hay etiquetas asociadas</p>
              <p class="text-sm text-gray-500 mt-1">Asocia etiquetas usando el botón "Nueva etiqueta"</p>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- 🆕 TÉRMINOS Y CONDICIONES DE DOMICILIACIÓN Section -->
      <div class="bg-white shadow-md rounded-lg mt-6">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <i class="fas fa-file-contract text-blue-600 mr-3"></i>
              <h2 class="text-xl font-bold text-gray-800">Términos y Condiciones de Domiciliación</h2>
            </div>
          </div>
        </div>

        <div class="p-6">
          <div class="bg-blue-50 rounded-lg p-4 border border-blue-200">
            <div class="flex items-start gap-4">
              <i class="fas fa-info-circle text-blue-600 text-xl mt-1"></i>
              <div class="flex-1">
                <h3 class="font-semibold text-blue-900 mb-2">Gestión de T&C por Banco</h3>
                <p class="text-blue-700 text-sm mb-4">
                  Configure los términos y condiciones que los clientes deben aceptar al domiciliar sus pagos.
                  Cada banco puede tener sus propios T&C específicos.
                </p>

                <!-- Lista de bancos con T&C configurados -->
                <div>
                  <h4 class="text-sm font-semibold text-gray-700 mb-2">
                    <i class="fas fa-list text-blue-600 mr-1"></i>
                    Estado de T&C por Banco
                  </h4>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div *ngFor="let bank of banksList" 
                         class="bg-gray-50 rounded p-3 text-sm border"
                         [ngClass]="bankHasTermsConfigured(bank.code) ? 'border-green-200 bg-green-50' : 'border-gray-200'">
                      <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                          <!-- Check verde si tiene T&C, gris si no -->
                          <i class="fas fa-check-circle text-lg"
                             [ngClass]="bankHasTermsConfigured(bank.code) ? 'text-green-600' : 'text-gray-300'"></i>
                          <div>
                            <div class="font-medium text-gray-800">{{ bank.name }}</div>
                            <div class="text-xs"
                                 [ngClass]="bankHasTermsConfigured(bank.code) ? 'text-green-600' : 'text-gray-500'">
                              {{ bankHasTermsConfigured(bank.code) ? 'T&C Configurados' : 'Sin configurar' }}
                            </div>
                          </div>
                        </div>
                        <!-- Botones de acción -->
                        <div class="flex items-center gap-2">
                          <!-- Botón Vista Previa (solo si tiene T&C) -->
                          <button 
                            *ngIf="bankHasTermsConfigured(bank.code)"
                            (click)="previewTermsConditions(selectedProductType.params.code, bank.code)"
                            class="text-xs px-3 py-1.5 rounded transition-colors flex items-center gap-1 bg-gray-100 text-gray-700 hover:bg-gray-200"
                            title="Vista previa">
                            <i class="fas fa-eye"></i>
                            <span>Vista Previa</span>
                          </button>
                          <!-- Botón Editar/Configurar -->
                          <button 
                            (click)="openTermsConditionsModal(selectedProductType.params.code, bank.code)"
                            class="text-xs px-3 py-1.5 rounded transition-colors flex items-center gap-1"
                            [ngClass]="bankHasTermsConfigured(bank.code) 
                              ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' 
                              : 'bg-blue-100 text-blue-700 hover:bg-blue-200'">
                            <i class="fas" [ngClass]="bankHasTermsConfigured(bank.code) ? 'fa-edit' : 'fa-plus-circle'"></i>
                            <span>{{ bankHasTermsConfigured(bank.code) ? 'Editar' : 'Configurar' }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="text-xs text-gray-500 mt-2" *ngIf="banksList.length === 0">
                    <i class="fas fa-exclamation-circle text-yellow-600 mr-1"></i>
                    No hay bancos disponibles. Configure los bancos domiciliables primero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- REMANENTE Y NETEO Section -->
      <div class="bg-white shadow-md rounded-lg mt-6">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center">
            <i class="fas fa-calculator text-gray-600 mr-3"></i>
            <h2 class="text-xl font-bold text-gray-800">Otros</h2>
          </div>
        </div>

        <div class="p-6">
          <div class="grid gap-6 lg:grid-cols-2">
            
            <!-- REMANENTE Configuration -->
            <div class="bg-gray-50 rounded-lg p-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="font-semibold text-gray-800">Remanente</h3>
                <label class="inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    [(ngModel)]="remanenteNeteoForm.remanente.status" 
                    (change)="onRemanenteToggle()"
                    class="sr-only peer" />
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
              
              <div *ngIf="remanenteNeteoForm.remanente.status">
                <label class="block text-sm font-medium text-gray-700 mb-2">Monto</label>
                <input 
                  type="number" 
                  [(ngModel)]="remanenteNeteoForm.remanente.amount"
                  (blur)="validateRemanenteAmount()"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="0.00" />
                <span class="text-red-500 text-sm" *ngIf="errorRemanenteAmount">Monto requerido y debe ser mayor a 0</span>
              </div>
            </div>

            <!-- NETEO Configuration -->
            <div class="bg-gray-50 rounded-lg p-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="font-semibold text-gray-800">Neteo</h3>
                <label class="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    [(ngModel)]="remanenteNeteoForm.neteo.status"
                    (change)="onNeteoToggle()"
                    class="sr-only peer" />
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>

              <div *ngIf="remanenteNeteoForm.neteo.status">
                <label class="block text-sm font-medium text-gray-700 mb-2">Monto</label>
                <input
                  type="number"
                  [(ngModel)]="remanenteNeteoForm.neteo.amount"
                  (blur)="validateNeteoAmount()"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="0.00" />
                <span class="text-red-500 text-sm" *ngIf="errorNeteoAmount">Monto requerido y debe ser mayor a 0</span>
              </div>
            </div>

             <!-- DOMICILIACIÓN Configuration -->
             <div class="bg-gray-50 rounded-lg p-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="font-semibold text-gray-800">Domiciliación</h3>
                <label class="inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    [(ngModel)]="remanenteNeteoForm.domiciliacion.status" 
                    (change)="onDomiciliacionToggle()"
                    class="sr-only peer" />
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
              
              <div *ngIf="remanenteNeteoForm.domiciliacion.status" class="text-sm text-gray-600">
                <p class="mb-6">Este producto permitirá activar la Domiciliación bancaria para cobrar sus cuotas.</p>
                <div class="space-y-4">
                  
                  <!-- Grupo 1: Bancos permitidos -->
                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between mb-3">
                      <div>
                        <label class="text-sm font-semibold text-gray-800 flex items-center">
                          <i class="fas fa-university mr-2 text-blue-600"></i>
                          Bancos permitidos
                        </label>
                        <p class="text-xs text-gray-600 mt-1">
                          <i class="fas fa-info-circle text-blue-600 mr-1"></i>
                          Cada banco puede tener sus propios T&C de domiciliación
                        </p>
                      </div>
                      <div class="flex items-center gap-2">
                        <button type="button" class="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200" (click)="selectAllBanks()">Todos</button>
                        <button type="button" class="text-xs px-2 py-1 bg-white text-gray-600 rounded hover:bg-gray-100" (click)="clearAllBanks()">Limpiar</button>
                      </div>
                    </div>
                    <div class="flex gap-2 mb-3">
                      <select [(ngModel)]="bankToAdd" class="flex-1 px-3 py-2 text-sm border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                        <option value="">Seleccionar banco</option>
                        <option *ngFor="let b of bankOptionsToAdd" [value]="b.code">{{b.name}} ({{b.code}})</option>
                      </select>
                      <button type="button" class="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed" [disabled]="!bankToAdd" (click)="addBank()">
                        <i class="fas fa-plus mr-1"></i>Agregar
                      </button>
                    </div>
                    <div class="border border-blue-200 rounded-lg bg-white p-3 min-h-[80px]">
                      <div *ngIf="selectedAllowedBanks.length > 0; else emptyBanks" class="space-y-2">
                        <div *ngFor="let code of selectedAllowedBanks" class="flex items-center justify-between p-2 bg-blue-50 rounded-lg border border-blue-200">
                          <div class="flex items-center gap-2">
                            <i class="fas fa-university text-blue-600"></i>
                            <span class="text-sm font-medium text-blue-900">{{ bankNameByCode(code) }}</span>
                          </div>
                          <div class="flex items-center gap-2">
                            <button 
                              type="button" 
                              (click)="openTermsConditionsModal(selectedProductType.params.code, code)"
                              class="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                              title="Configurar T&C de domiciliación">
                              <i class="fas fa-file-contract mr-1"></i>
                              T&C
                            </button>
                            <button type="button" class="text-blue-600 hover:text-blue-800 focus:outline-none" (click)="removeBank(code)">
                              <i class="fas fa-times text-sm"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ng-template #emptyBanks>
                        <div class="flex flex-col items-center justify-center py-4 text-gray-400">
                          <i class="fas fa-university text-2xl mb-2"></i>
                          <p class="text-xs text-center">No hay bancos seleccionados</p>
                          <p class="text-xs text-center mt-1">Usa el selector para agregar bancos</p>
                        </div>
                      </ng-template>
                    </div>
                    <p class="text-xs text-gray-600 mt-2"><i class="fas fa-info-circle mr-1"></i>Si no seleccionas bancos, se mostrarán todos en el módulo de domiciliación.</p>
                  </div>

                  <!-- Grupo 2: Tipos permitidos -->
                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between mb-3">
                      <label class="text-sm font-semibold text-gray-800">
                        <i class="fas fa-list-ul mr-2 text-blue-600"></i>
                        Tipos permitidos
                      </label>
                      <div class="flex items-center gap-2">
                        <button type="button" class="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200" (click)="selectAllTypes()">Todos</button>
                        <button type="button" class="text-xs px-2 py-1 bg-white text-gray-600 rounded hover:bg-gray-100" (click)="clearAllTypes()">Limpiar</button>
                      </div>
                    </div>
                    <div class="flex gap-2 mb-3">
                      <select [(ngModel)]="typeToAdd" class="flex-1 px-3 py-2 text-sm border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                        <option [ngValue]="null">Seleccionar tipo</option>
                        <option *ngFor="let t of typeOptionsToAdd" [ngValue]="t.id">{{t.name}}</option>
                      </select>
                      <button type="button" class="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed" [disabled]="typeToAdd===null" (click)="addType()">
                        <i class="fas fa-plus mr-1"></i>Agregar
                      </button>
                    </div>
                    <div class="border border-blue-200 rounded-lg bg-white p-3 min-h-[80px] max-h-40 overflow-auto">
                      <div *ngIf="selectedAllowedTypes.length > 0; else emptyTypes" class="flex flex-wrap gap-2">
                        <span *ngFor="let id of selectedAllowedTypes" class="inline-flex items-center px-3 py-1.5 bg-blue-100 text-blue-800 rounded-full text-xs font-medium border border-blue-300">
                          {{ typeNameById(id) }}
                          <button type="button" class="ml-2 text-blue-600 hover:text-blue-800 focus:outline-none" (click)="removeType(id)">
                            <i class="fas fa-times text-xs"></i>
                          </button>
                        </span>
                      </div>
                      <ng-template #emptyTypes>
                        <div class="flex flex-col items-center justify-center py-4 text-gray-400">
                          <i class="fas fa-list-ul text-2xl mb-2"></i>
                          <p class="text-xs text-center">No hay tipos seleccionados</p>
                          <p class="text-xs text-center mt-1">Usa el selector para agregar tipos</p>
                        </div>
                      </ng-template>
                    </div>
                    <p class="text-xs text-gray-600 mt-2"><i class="fas fa-info-circle mr-1"></i>Si no seleccionas tipos, se mostrarán todos los tipos disponibles.</p>
                  </div>

                  <!-- Grupo 3: Configuración de Tasa Externa -->
                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between mb-4">
                      <div>
                        <h4 class="text-sm font-semibold text-gray-800 flex items-center">
                          <i class="fas fa-exchange-alt mr-2 text-blue-600"></i>
                          Usar Tasa Externa
                        </h4>
                        <p class="text-xs text-gray-600 mt-1">Utilizar una tasa de cambio diferente a la predeterminada</p>
                      </div>
                      <label class="inline-flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          [(ngModel)]="remanenteNeteoForm.domiciliacion.use_external_rate" 
                          (change)="onExternalRateToggle()"
                          class="sr-only peer" />
                        <div class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>

                    <div *ngIf="remanenteNeteoForm.domiciliacion.use_external_rate">
                      <label class="block text-sm font-medium text-gray-700 mb-2">
                        <i class="fas fa-tag mr-1"></i>Canal de Tasa Externa<span class="text-red-500">*</span>
                      </label>
                      <select
                        [(ngModel)]="remanenteNeteoForm.domiciliacion.external_rate_channel"
                        (change)="validateExternalRateChannel()"
                        class="w-full px-3 py-2 text-sm border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                        <option value="">Seleccionar canal de tasa</option>
                        <option value="SEGUROS_MERCANTIL">
                          <i class="fas fa-shield-alt"></i> Seguros Mercantil
                        </option>
                        <!-- Aquí se pueden agregar más canales en el futuro -->
                      </select>
                      <span class="text-red-500 text-xs mt-1" *ngIf="errorExternalRateChannel">Canal de tasa requerido</span>
                      <p class="text-xs text-gray-600 mt-2">
                        <i class="fas fa-info-circle mr-1"></i>
                        Esta tasa se utilizará para calcular los montos en la domiciliación bancaria
                      </p>
                    </div>
                  </div>

                  <!-- Grupo 4: Límite de Reintentos -->
                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between mb-3">
                      <div>
                        <h4 class="text-sm font-semibold text-gray-800 flex items-center">
                          <i class="fas fa-calendar-times mr-2 text-blue-600"></i>
                          Límite de Días de Reintentos
                        </h4>
                        <p class="text-xs text-gray-600 mt-1">Establecer un máximo de días para intentar la domiciliación</p>
                      </div>
                      <label class="inline-flex items-center cursor-pointer">
                        <input 
                          type="checkbox"
                          [(ngModel)]="remanenteNeteoForm.domiciliacion.retry_limit_enabled" 
                          (change)="onRetryLimitToggle()"
                          class="sr-only peer" />
                        <div class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>

                    <div *ngIf="remanenteNeteoForm.domiciliacion.retry_limit_enabled" class="space-y-4">
                      <!-- Días límite -->
                      <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                          <i class="fas fa-hashtag mr-1"></i>Días Máximos<span class="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          min="1"
                          [(ngModel)]="remanenteNeteoForm.domiciliacion.retry_limit_days"
                          (change)="validateRetryLimitDays()"
                          placeholder="Ej: 30"
                          class="w-full px-3 py-2 text-sm border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                        <span class="text-red-500 text-xs mt-1" *ngIf="errorRetryLimitDays">Días requeridos (mayor a 0)</span>
                        <p class="text-xs text-gray-600 mt-2">
                          <i class="fas fa-info-circle mr-1"></i>
                          Solo se intentará domiciliar hasta este número de días después del vencimiento
                        </p>
                      </div>

                      <!-- Excluir fines de semana -->
                      <div class="bg-white border border-blue-200 rounded-lg p-3">
                        <div class="flex items-start justify-between">
                          <div class="flex-1">
                            <h5 class="text-sm font-medium text-gray-800 mb-1">
                              <i class="fas fa-calendar-week mr-1 text-blue-600"></i>
                              Excluir Fines de Semana
                            </h5>
                            <p class="text-xs text-gray-600">
                              Activado: Solo cuenta días hábiles (lunes a viernes)<br>
                              Desactivado: Cuenta días continuos (incluye sábados y domingos)
                            </p>
                          </div>
                          <label class="inline-flex items-center cursor-pointer ml-3">
                            <input 
                              type="checkbox" 
                              [(ngModel)]="remanenteNeteoForm.domiciliacion.exclude_weekends" 
                              class="sr-only peer" />
                            <div class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                          </label>
                        </div>
                        
                        <!-- Indicador visual -->
                        <div class="mt-3 pt-3 border-t border-blue-100">
                          <div class="flex items-center text-xs">
                            <i [class]="remanenteNeteoForm.domiciliacion.exclude_weekends ? 'fas fa-briefcase text-blue-600' : 'fas fa-calendar-alt text-gray-500'" class="mr-2"></i>
                            <span [class]="remanenteNeteoForm.domiciliacion.exclude_weekends ? 'text-blue-700 font-medium' : 'text-gray-600'">
                              {{ remanenteNeteoForm.domiciliacion.exclude_weekends ? 'Solo días hábiles' : 'Días continuos' }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Ejemplo visual -->
                      <div class="bg-white border-l-4 border-blue-400 p-3 rounded-r">
                        <div class="flex items-start">
                          <i class="fas fa-lightbulb text-blue-600 text-sm mt-0.5 mr-2"></i>
                          <div class="text-xs text-gray-700">
                            <strong>Ejemplo:</strong> Si configuras 
                            <span class="font-mono bg-blue-100 text-blue-800 px-1 rounded">{{remanenteNeteoForm.domiciliacion.retry_limit_days || 30}}</span> días
                            <span *ngIf="remanenteNeteoForm.domiciliacion.exclude_weekends"> hábiles</span>
                            <span *ngIf="!remanenteNeteoForm.domiciliacion.exclude_weekends"> continuos</span>,
                            una cuota vencida hace 
                            <span class="font-mono bg-blue-100 text-blue-800 px-1 rounded">{{(remanenteNeteoForm.domiciliacion.retry_limit_days || 30) + 1}}</span> días
                            <strong>NO</strong> se incluirá en la domiciliación.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Grupo 5: Cobranza Escalonada -->
                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between mb-3">
                      <div>
                        <h4 class="text-sm font-semibold text-gray-800 flex items-center">
                          <i class="fas fa-layer-group mr-2 text-blue-600"></i>
                          Cobranza Escalonada
                        </h4>
                        <p class="text-xs text-gray-600 mt-1">Procesar solo la cuota más antigua pendiente por cliente</p>
                      </div>
                      <label class="inline-flex items-center cursor-pointer">
                        <input 
                          type="checkbox"
                          [(ngModel)]="remanenteNeteoForm.domiciliacion.staggered_collection" 
                          class="sr-only peer" />
                        <div class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>
                    
                    <div class="bg-white border border-blue-200 rounded-lg p-3">
                      <div class="flex items-start">
                        <i class="fas fa-info-circle text-blue-600 text-sm mt-0.5 mr-2"></i>
                        <div class="text-xs text-gray-700">
                          <p class="mb-2"><strong>¿Qué es la Cobranza Escalonada?</strong></p>
                          <p class="mb-2">Cuando está <strong class="text-blue-700">activada</strong>, el sistema filtrará y procesará únicamente la cuota más antigua (con fecha de vencimiento más lejana) que esté pendiente de pago por cada cliente.</p>
                          <p class="mb-2"><strong>Ventajas:</strong></p>
                          <ul class="list-disc list-inside space-y-1 ml-2">
                            <li>Evita intentar cobrar múltiples cuotas simultáneamente.</li>
                            <li>Permite un flujo de cobro ordenado y progresivo</li>
                          </ul>
                          <p class="mt-2 text-blue-700"><strong>Ejemplo:</strong> Si un cliente tiene 3 cuotas vencidas (enero, febrero, marzo), solo se intentará domiciliar la de enero.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Grupo 6: Distribución con Referencia Directa -->
                  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between mb-3">
                      <div>
                        <h4 class="text-sm font-semibold text-gray-800 flex items-center">
                          <i class="fas fa-link mr-2 text-blue-600"></i>
                          Distribución con Referencia Directa
                        </h4>
                        <p class="text-xs text-gray-600 mt-1">Aplicar el pago directamente a la cuota específica procesada</p>
                      </div>
                      <label class="inline-flex items-center cursor-pointer">
                        <input 
                          type="checkbox"
                          [(ngModel)]="remanenteNeteoForm.domiciliacion.direct_reference_payment" 
                          class="sr-only peer" />
                        <div class="relative w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>
                    
                    <div class="bg-white border border-blue-200 rounded-lg p-3">
                      <div class="flex items-start">
                        <i class="fas fa-info-circle text-blue-600 text-sm mt-0.5 mr-2"></i>
                        <div class="text-xs text-gray-700">
                          <p class="mb-2"><strong>¿Qué es la Distribución con Referencia Directa?</strong></p>
                          <p class="mb-2">Cuando está <strong class="text-blue-700">activada</strong>, el pago recibido se aplicará exclusivamente a la cuota específica que generó la domiciliación, utilizando su referencia única.</p>
                          <p class="mb-2"><strong>Ventajas:</strong></p>
                          <ul class="list-disc list-inside space-y-1 ml-2">
                            <li>Garantiza aplicar el pago exacto a la cuota.</li>
                            <li>Evita distribuciones automáticas no deseadas</li>
                            <li>Facilita la conciliación y auditoría de pagos</li>
                            <li>Ideal para productos con cuotas independientes y que requieren cobros especificos y no globales.</li>
                          </ul>
                          <p class="mt-2 text-blue-700"><strong>Ejemplo:</strong> Si se domicilia la cuota #5, el pago se aplicará solo a esa cuota, no a otras pendientes para el mismo tipo de producto.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- PENALIDADES Configuration -->
            <div class="bg-gray-50 rounded-lg p-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="font-semibold text-gray-800">Penalidades</h3>
                <label class="inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    [(ngModel)]="remanenteNeteoForm.fees.status" 
                    (change)="onFeesToggle()"
                    class="sr-only peer" />
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
              
              <div *ngIf="remanenteNeteoForm.fees.status" class="space-y-3 mt-2">
                <!-- Tip: Penalidades Activadas -->
                <div class="bg-green-50 border-l-4 border-green-500 p-3 rounded-r">
                  <div class="flex items-start">
                    <div class="flex-shrink-0">
                      <i class="fas fa-check-circle text-green-500 text-lg mt-0.5"></i>
                    </div>
                    <div class="ml-3 flex-1">
                      <div class="flex items-center mb-1">
                        <span class="text-xs font-semibold text-green-800 bg-green-200 px-2 py-0.5 rounded">PENALIDADES ON</span>
                      </div>
                      <p class="text-sm text-green-800">
                        <strong>Todos los planes</strong> del producto tendrán las penalidades <strong>activas por defecto</strong>.
                      </p>
                      <p class="text-xs text-green-700 mt-1">
                        <i class="fas fa-ban mr-1"></i>
                        Para excluir una penalidad específica, agrégala a la <strong>Lista Negra</strong> del plan.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Tip: Penalidades Desactivadas -->
                <div class="bg-amber-50 border-l-4 border-amber-500 p-3 rounded-r">
                  <div class="flex items-start">
                    <div class="flex-shrink-0">
                      <i class="fas fa-info-circle text-amber-500 text-lg mt-0.5"></i>
                    </div>
                    <div class="ml-3 flex-1">
                      <div class="flex items-center mb-1">
                        <span class="text-xs font-semibold text-amber-800 bg-amber-200 px-2 py-0.5 rounded">PENALIDADES OFF</span>
                      </div>
                      <p class="text-sm text-amber-800">
                        <strong>Ningún plan</strong> aplicará penalidades de forma automática.
                      </p>
                      <p class="text-xs text-amber-700 mt-1">
                        <i class="fas fa-check-circle mr-1"></i>
                        Para activar una penalidad específica, agrégala a la <strong>Lista Blanca</strong> del plan.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ORDEN DE VISUALIZACIÓN Configuration -->
            <div class="bg-gray-50 rounded-lg p-4">
              <div class="mb-4">
                <h3 class="font-semibold text-gray-800 mb-2">
                  <i class="fas fa-sort-numeric-down mr-2"></i>Orden de Visualización
                </h3>
                <p class="text-xs text-gray-600">Define el orden en que se mostrará este producto en las apps</p>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Orden</label>
                <input 
                  type="number" 
                  min="0"
                  [(ngModel)]="remanenteNeteoForm.display_order"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="0" />
                <p class="text-xs text-gray-500 mt-2">
                  <i class="fas fa-info-circle mr-1"></i>
                  Los productos se ordenarán de menor a mayor (0 = primero)
                </p>
              </div>
            </div>

          </div>

          <!-- Save button -->
          <div class="mt-6 flex justify-end">
            <button 
              (click)="saveRemanenteNeteoConfig()" 
              [disabled]="isLoading"
              class="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 disabled:opacity-50 transition-colors">
              <div *ngIf="isLoading" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              <i *ngIf="!isLoading" class="fas fa-save mr-2"></i>
              <span>{{isLoading ? 'Guardando...' : 'Guardar Configuración'}}</span>
            </button>
          </div>
        </div>
      </div>


    

     
      
    </div>
  </section>

  <!-- 🆕 MODAL: TÉRMINOS Y CONDICIONES DE DOMICILIACIÓN -->
  <div *ngIf="isModalTermsConditionsOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
      
      <!-- Header -->
      <div class="px-6 py-4 border-b border-gray-200 bg-blue-50">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <i class="fas fa-file-contract text-blue-600 text-2xl"></i>
            <div>
              <h3 class="text-xl font-bold text-gray-800">
                {{ isEditingTerms ? 'Editar' : 'Crear' }} Términos y Condiciones
              </h3>
              <p class="text-sm text-gray-600 mt-1">
                <span class="inline-flex items-center gap-2">
                  <i class="fas fa-university text-blue-600"></i>
                  <strong>{{ bankNameByCode(termsConditionsForm.bank_code) }}</strong>
                  <span class="text-gray-400">•</span>
                  <strong>{{ getProductName(termsConditionsForm.product_type) }}</strong>
                </span>
                <span *ngIf="currentTermsVersion" class="ml-2 text-blue-600">
                  (Versión actual: {{ currentTermsVersion.version }})
                </span>
              </p>
            </div>
          </div>
          <button 
            (click)="closeTermsConditionsModal()" 
            class="text-gray-400 hover:text-gray-600 transition-colors">
            <i class="fas fa-times text-2xl"></i>
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="flex-1 overflow-y-auto p-6">
        
        <!-- Loading State -->
        <div *ngIf="isLoadingTerms" class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p class="text-gray-600">Cargando...</p>
          </div>
        </div>

        <!-- Form -->
        <div *ngIf="!isLoadingTerms && !showTermsHistory" class="space-y-6">
          
          <!-- Nombre del T&C -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Nombre del T&C <span class="text-red-500">*</span>
            </label>
            <input 
              type="text"
              [(ngModel)]="termsConditionsForm.name"
              [class.border-red-500]="errorTermsName"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Ej: Términos y Condiciones de Domiciliación - Crédito BLVF">
            <p *ngIf="errorTermsName" class="text-red-500 text-sm mt-1">
              <i class="fas fa-exclamation-circle"></i> El nombre es requerido
            </p>
          </div>

          <!-- Contenido HTML del T&C con Editor Rico -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Contenido del T&C <span class="text-red-500">*</span>
            </label>
            <div [class.border-red-500]="errorTermsDetails" class="border rounded-lg">
              <quill-editor 
                [(ngModel)]="termsConditionsForm.details"
                [modules]="quillModules"
                [styles]="editorStyle"
                placeholder="Escriba el contenido de los Términos y Condiciones aquí...">
              </quill-editor>
            </div>
            <p *ngIf="errorTermsDetails" class="text-red-500 text-sm mt-1">
              <i class="fas fa-exclamation-circle"></i> El contenido es requerido
            </p>
            <p class="text-gray-500 text-xs mt-2">
              <i class="fas fa-magic text-blue-600 mr-1"></i> 
              Use la barra de herramientas para formatear el texto (negrita, cursiva, listas, etc.)
            </p>
            
            <!-- Botón de Vista Previa del contenido -->
            <button 
              *ngIf="termsConditionsForm.details && termsConditionsForm.details.trim()"
              (click)="togglePreviewMode()"
              type="button"
              class="mt-3 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-2">
              <i class="fas" [ngClass]="showPreview ? 'fa-edit' : 'fa-eye'"></i>
              <span>{{ showPreview ? 'Volver al Editor' : 'Vista Previa' }}</span>
            </button>

            <!-- Panel de Vista Previa -->
            <div *ngIf="showPreview" class="mt-4 p-4 bg-white border-2 border-gray-300 rounded-lg">
              <div class="flex items-center justify-between mb-3 pb-2 border-b">
                <h4 class="font-semibold text-gray-800 flex items-center gap-2">
                  <i class="fas fa-eye text-blue-600"></i>
                  Vista Previa - Cómo se verá en producción
                </h4>
              </div>
              <div class="prose max-w-none" [innerHTML]="termsConditionsForm.details"></div>
            </div>
          </div>

          <!-- Info sobre versionamiento -->
          <div *ngIf="isEditingTerms" class="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r">
            <div class="flex items-start">
              <i class="fas fa-exclamation-triangle text-yellow-600 text-lg mt-0.5 mr-3"></i>
              <div>
                <h4 class="font-semibold text-yellow-800 mb-1">Importante: Versionamiento</h4>
                <p class="text-yellow-700 text-sm">
                  Al guardar los cambios, se creará una nueva versión (v{{ currentTermsVersion.version + 1 }}) 
                  y la versión actual (v{{ currentTermsVersion.version }}) se desactivará automáticamente.
                  El historial completo se mantendrá para auditoría.
                </p>
              </div>
            </div>
          </div>

        </div>

        <!-- Historial de Versiones -->
        <div *ngIf="showTermsHistory" class="space-y-4">
          <div class="flex items-center justify-between mb-4">
            <h4 class="text-lg font-semibold text-gray-800">Historial de Versiones</h4>
            <button 
              (click)="hideTermsHistory()"
              class="text-purple-600 hover:text-purple-700 text-sm font-medium">
              <i class="fas fa-arrow-left mr-1"></i> Volver al editor
            </button>
          </div>

          <div *ngIf="termsHistory.length === 0" class="text-center py-8 text-gray-500">
            <i class="fas fa-history text-4xl mb-3"></i>
            <p>No hay historial de versiones</p>
          </div>

          <div *ngFor="let version of termsHistory" class="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
            <div class="flex items-start justify-between">
              <div class="flex-1">
                <div class="flex items-center gap-3 mb-2">
                  <span class="px-3 py-1 rounded-full text-sm font-semibold"
                        [class.bg-green-100]="version.status === 'ACTIVE'"
                        [class.text-green-800]="version.status === 'ACTIVE'"
                        [class.bg-gray-100]="version.status === 'INACTIVE'"
                        [class.text-gray-800]="version.status === 'INACTIVE'">
                    <i class="fas" [class.fa-check-circle]="version.status === 'ACTIVE'" 
                                   [class.fa-archive]="version.status === 'INACTIVE'"></i>
                    {{ version.status === 'ACTIVE' ? 'Activa' : 'Inactiva' }}
                  </span>
                  <span class="text-lg font-bold text-purple-600">Versión {{ version.version }}</span>
                </div>
                
                <h5 class="font-medium text-gray-800 mb-2">{{ version.name }}</h5>
                
                <div class="grid grid-cols-2 gap-3 text-sm text-gray-600">
                  <div>
                    <i class="fas fa-calendar text-purple-600 mr-1"></i>
                    Creada: {{ formatDate(version.createdAt) }}
                  </div>
                  <div *ngIf="version.edited_at">
                    <i class="fas fa-edit text-purple-600 mr-1"></i>
                    Editada: {{ formatDate(version.edited_at) }}
                  </div>
                  <div *ngIf="version.created_by">
                    <i class="fas fa-user text-purple-600 mr-1"></i>
                    Creado por: {{ version.created_by.name || version.created_by.username }}
                  </div>
                  <div *ngIf="version.edited_by">
                    <i class="fas fa-user-edit text-purple-600 mr-1"></i>
                    Editado por: {{ version.edited_by.name || version.edited_by.username }}
                  </div>
                  <div *ngIf="version.end_date">
                    <i class="fas fa-clock text-gray-600 mr-1"></i>
                    Fin de vigencia: {{ formatDate(version.end_date) }}
                  </div>
                </div>
              </div>
              
              <!-- Botón de Preview -->
              <div class="ml-4">
                <button 
                  (click)="previewTermsVersion(version)"
                  class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2">
                  <i class="fas fa-eye"></i>
                  <span>Ver Preview</span>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-between">
        <div>
          <button 
            *ngIf="isEditingTerms && !showTermsHistory"
            (click)="viewTermsHistory()"
            class="px-4 py-2 text-purple-600 hover:text-purple-700 font-medium transition-colors">
            <i class="fas fa-history mr-2"></i>
            Ver Historial
          </button>
        </div>
        
        <div class="flex gap-3">
          <button 
            (click)="closeTermsConditionsModal()" 
            [disabled]="isLoadingTerms"
            class="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50">
            Cancelar
          </button>
          <button 
            *ngIf="!showTermsHistory"
            (click)="saveTermsConditions()" 
            [disabled]="isLoadingTerms"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center gap-2">
            <div *ngIf="isLoadingTerms" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            <i *ngIf="!isLoadingTerms" class="fas fa-save"></i>
            <span>{{ isLoadingTerms ? 'Guardando...' : (isEditingTerms ? 'Guardar Cambios' : 'Crear T&C') }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</div> 